import { render } from "./QuotationDetails.vue?vue&type=template&id=0df65f1f&scoped=true&ts=true"
import script from "./QuotationDetails.vue?vue&type=script&lang=ts"
export * from "./QuotationDetails.vue?vue&type=script&lang=ts"

import "./QuotationDetails.vue?vue&type=style&index=0&id=0df65f1f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df65f1f"]])

export default __exports__